import { useEffect, useState } from "react";
import Subheader from "@/components/Headers/Subheader";
import ProductsGrid from "@/components/ProductsGrid";
import triggerAnalyticsEvent, { dispatchMKPLCustomEvent } from "@/helpers/triggerAnalyticsEvent";
import Prefooter from "@/components/Prefooter";


function  setURLParams(input: string) {
  const urlParams = new URLSearchParams(window.location.search);
  urlParams.delete("q");
  history.pushState(
    null,
    "",
    `${window.location.pathname}?q=${encodeURIComponent(input)}`
  );
}

const SearchPage = ({count,onSearchSubmit = () => {}} : {count:number, onSearchSubmit?: (query: boolean) => void;}) => {
  useEffect(() => {
    window.scrollTo(0, 0);
    console.log(count);
    triggerAnalyticsEvent({
      PageName: "searchresult",
      pageKind: "searchinspiration-search",
      pageFunction: "searchresult",
      ABTestname: "",
      domainidentifier: "Joyhunt",
    });
    if(_SFDDL.pageInfo.hasOwnProperty("ErrorMessage")) {
      delete _SFDDL.pageInfo.ErrorMessage;
    }
    if(_SFDDL.pageInfo.hasOwnProperty("MessageType")) {
      delete _SFDDL.pageInfo.MessageType;
    }
    if(_SFDDL.pageInfo.hasOwnProperty("RelyingParty")) {
      delete _SFDDL.pageInfo.RelyingParty;
    }
    if(_SFDDL.pageInfo.hasOwnProperty("pageName")) {
      delete _SFDDL.pageInfo.pageName;
    }
    initialPageLoad = false;
    dispatchMKPLCustomEvent();
  }, []);

  const [prompt, setPrompt] = useState("");
  const [reload, setReload] = useState<number>(0);
  const handlePrompt = (query: string) => {
    if(query.includes(prompt) && (query.length-prompt.length) <= 1) {
      handleCount();
    } else {
      setPrompt(query);
    }
  };

  const handleCount = () => {
    let temp = reload;
    temp += 1;
    setReload(temp);
  }
 
  return (
    <>
      <main className="min-h-screen">
        <Subheader handlePrompt={handlePrompt} onSearchSubmit={onSearchSubmit} />
        <ProductsGrid prompt={prompt} reload={reload} handlePrompt={handlePrompt}  onSearchSubmit={onSearchSubmit}  />
      </main>
      <div className="mt-[24px]">
        <Prefooter showTradeMarkDisclaimer />
      </div>
    </>
  );
};

export default SearchPage;
